import { Skeleton, Row, Col, Upload, Divider, Card, notification } from 'antd';
import { Form, FormItem, Input, Toggle } from 'asumsi-components';
import React, { useEffect, useState } from 'react';
import ImgCrop from 'antd-img-crop';

export const PageMetaDataPostFormComponent = (props: any) => {
    // declare action and attribute needed
    const { isLoader, fieldsValues, setFieldsValues } = props;

    const [fileList, setFileList] = useState([]);
    const [fileListFB, setFileListFB] = useState([]);
    const [fileListTwitter, setFileListTwitter] = useState([]);
    const [facebook, setFacebook] = useState(false);
    const [twitter, settwitter] = useState(false);

    useEffect(() => {
        defaultActiveMedia();
    }, []);

    const defaultActiveMedia = () => {
        const metaImageUrl = fieldsValues.imageUrl ? fieldsValues.imageUrl.split('/') : [];
        const metaFbImageUrl = fieldsValues.fbImageUrl ? fieldsValues.fbImageUrl.split('/') : [];
        const metaTwitterImageUrl = fieldsValues.twitImageUrl ? fieldsValues.twitImageUrl.split('/') : [];
        let sameFBImage: boolean = true;
        if (metaFbImageUrl.length > 0) {
            sameFBImage = metaImageUrl.length > 0 ? metaImageUrl[metaImageUrl.length - 1].split("_")[1] == metaFbImageUrl[metaFbImageUrl.length - 1].split("_")[1] : metaImageUrl.length == metaFbImageUrl.length;
        }

        let sameTwitterImage: boolean = true;
        if (metaTwitterImageUrl.length > 0) {
            sameTwitterImage = metaImageUrl.length > 0 ? metaImageUrl[metaImageUrl.length - 1].split("_")[1] == metaTwitterImageUrl[metaTwitterImageUrl.length - 1].split("_")[1] : metaImageUrl.length == metaTwitterImageUrl.length;
        }

        if (sameFBImage && fieldsValues.metaTitle == fieldsValues.fbTitle && fieldsValues.metaDescription == fieldsValues.fbDescription) {
            setFacebook(false);
        } else {
            setFacebook(true);
        }

        if (sameTwitterImage && fieldsValues.metaTitle == fieldsValues.twitTitle && fieldsValues.metaDescription == fieldsValues.twitDescription) {
            settwitter(false);
        } else {
            settwitter(true);
        }
    }
    const onChangeMetaImage = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        setFileList(newFileList);
        if (!facebook) {
            setFileListFB(newFileList);
        }

        if (!twitter) {
            setFileListTwitter(newFileList);
        }
        setFieldsValues({
            ...fieldsValues,
            image: newFileList[0] ? newFileList[0].originFileObj : null,
            facebookCardImage: !facebook ? newFileList[0] ? newFileList[0].originFileObj : null : fieldsValues.facebookCardImage,
            twitterCardImage: !twitter ? newFileList[0] ? newFileList[0].originFileObj : null : fieldsValues.twitterCardImage
        });
    };

    const onChangeFBImage = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        setFileListFB(newFileList);
        setFieldsValues({ ...fieldsValues, facebookCardImage: newFileList[0] ? newFileList[0].originFileObj : null });
    };

    const onChangeTwitterImage = async ({ fileList: newFileList }: any) => {
        if (newFileList[0]) {
            const tumbnail = await getBase64(newFileList[0].originFileObj);
            newFileList[0].thumbUrl = tumbnail;
            newFileList[0].status = 'done';
        }
        setFileListTwitter(newFileList);
        setFieldsValues({ ...fieldsValues, twitterCardImage: newFileList[0] ? newFileList[0].originFileObj : null });
    };

    const onPreview = async (file: any) => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        if (imgWindow) {
            imgWindow.document.write(image.outerHTML);
        }
    };

    const beforeUpload = (file: any) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            notification.error({
                description: "You can only upload JPG/PNG file",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({
                description: "Image must smaller than 2MB!",
                duration: 5,
                message: 'Failed',
            });
            //   message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    const emptyImage = (widthImage: string, heightImage: string) => <div className="empty-upload">
        <Row justify="space-around" align="middle" style={{ height: "100%" }}>
            <Col style={{ height: "100%" }}>
                {/* <Col span={24} className="size"> */}
                <p className="size">{`${widthImage}x${heightImage}px`}</p>
                {/* </Col> */}
                {/* <Col span={24} className="desc"> */}
                <p className="desc">Click to browse or drag file to this area to upload</p>
                {/* </Col> */}
            </Col>
        </Row>
    </div>;

    const defaultImage = (imageUrl: string, dataType: string) => {
        const onDeleteImage = () => {
            const image: any = {};
            image[dataType] = null
            setFieldsValues({ ...fieldsValues, ...image });
        }
        const pathUrl = imageUrl.split('/');
        return <div className="ant-upload-list ant-upload-list-picture">
            <div>
                <span>
                    <div className="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture">
                        <div className="ant-upload-list-item-info">
                            <span>
                                <a className="ant-upload-list-item-thumbnail" href={imageUrl} target="_blank" rel="noopener noreferrer">
                                    <img src={imageUrl} className="ant-upload-list-item-image"></img>
                                </a>
                                <span className="ant-upload-list-item-name ant-upload-list-item-name-icon-count-1" title="005940800_1552970791-fotoHL_kucing.jpg">
                                    {pathUrl[pathUrl.length - 1]}
                                </span>
                                <span className="ant-upload-list-item-card-actions picture">
                                    <a title="Remove file" onClick={onDeleteImage}>
                                        <i aria-label="icon: delete" title="Remove file" className="anticon anticon-delete">
                                            <svg viewBox="64 64 896 896" focusable="false" data-icon="delete" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                                <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z">
                                                </path>
                                            </svg>
                                        </i>
                                    </a>
                                </span>
                            </span>
                        </div>
                    </div>
                </span>
            </div>
        </div>
    }

    const getBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const changeFB = (e: any) => {
        setFacebook(e.target.checked);
    }

    const changeTwitter = (e: any) => {
        settwitter(e.target.checked);
    }

    const onChangeMetaTitle = (e: any) => {
        setFieldsValues({
            ...fieldsValues,
            metaTitle: e.target.value,
            fbTitle: !facebook ? e.target.value : fieldsValues.fbTitle,
            twitTitle: !twitter ? e.target.value : fieldsValues.twitTitle
        });
    }

    const changeMetaDesc = (e: any) => {
        setFieldsValues({
            ...fieldsValues,
            metaDescription: e.target.value,
            fbDescription: !facebook ? e.target.value : fieldsValues.fbDescription,
            twitDescription: !twitter ? e.target.value : fieldsValues.twitDescription
        });
    }

    // return JSX Element 
    return (
        <div>
            <Form titleBold={true} loading={isLoader}>
                <Skeleton loading={isLoader}>
                    <Row gutter={30}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <Row>
                                <Col span={12}>
                                    <Row>
                                        <Col span={24}>
                                            <FormItem className="meta-image" setFieldsValues={setFieldsValues} label="Image" fieldsValues={fieldsValues} labelAlign="left"
                                                fieldDecorator={{
                                                    label: "image"
                                                }}
                                            >
                                                {fieldsValues.imageUrl ? defaultImage(fieldsValues.imageUrl, 'imageUrl') :
                                                    <ImgCrop aspect={1.910828025} rotate>
                                                        <Upload
                                                            listType="picture"
                                                            fileList={fileList}
                                                            openFileDialogOnClick={true}
                                                            onChange={onChangeMetaImage}
                                                            onPreview={onPreview}
                                                            beforeUpload={beforeUpload}
                                                        >
                                                            {fileList.length == 0 && emptyImage("1200", "628")}
                                                        </Upload>
                                                    </ImgCrop>}

                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <FormItem width="95%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Image By" labelAlign="left"
                                                fieldDecorator={{
                                                    label: "imageCreditBy"
                                                }}
                                            >
                                                <Input id="imageCreditBy" defaultValue={fieldsValues.imageCreditBy} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <FormItem width="95%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                                fieldDecorator={{
                                                    label: "metaTitle"
                                                }}
                                            >
                                                <Input id="metaTitle" defaultValue={fieldsValues.metaTitle} onChange={onChangeMetaTitle} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <FormItem width="95%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                                fieldDecorator={{
                                                    label: "metaDescription"
                                                }}
                                            >
                                                <textarea className="asumsi-input textarea" id="metaDescription" defaultValue={fieldsValues.metaDescription} onChange={changeMetaDesc} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <FormItem width="95%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Canonical URL" labelAlign="left"
                                                fieldDecorator={{
                                                    label: "canonicalUrl"
                                                }}
                                            >
                                                <Input id="canonicalUrl" defaultValue={fieldsValues.canonicalUrl} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Card className="card-media">
                                        <Row>
                                            <Col span={12} style={{ fontWeight: 600 }}>Custom Facebook Metadata</Col>
                                            <Col span={12} className="right">
                                                <Toggle id="status" defaultChecked={facebook} onChange={changeFB} checked={facebook} />
                                            </Col>
                                        </Row>
                                        <div className={facebook ? 'm-t-10' : `hidden`}>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem className="meta-image" setFieldsValues={setFieldsValues} label="Image" fieldsValues={fieldsValues} labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "facebookCardImage"
                                                        }}
                                                    >
                                                        {fieldsValues.fbImageUrl ? defaultImage(fieldsValues.fbImageUrl, "fbImageUrl") :
                                                            <ImgCrop aspect={1.910828025} rotate>
                                                                <Upload
                                                                    listType="picture"
                                                                    fileList={fileListFB}
                                                                    openFileDialogOnClick={true}
                                                                    onChange={onChangeFBImage}
                                                                    onPreview={onPreview}
                                                                    beforeUpload={beforeUpload}
                                                                >
                                                                    {fileListFB.length == 0 && emptyImage("1200", "628")}
                                                                </Upload>
                                                            </ImgCrop>}

                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "fbTitle"
                                                        }}
                                                    >
                                                        <Input id="fbTitle" defaultValue={fieldsValues.fbTitle} />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "fbDescription"
                                                        }}
                                                    >
                                                        <textarea className="asumsi-input textarea" id="fbDescription" defaultValue={fieldsValues.fbDescription} />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                    <Card className="card-media" style={{ marginTop: "20px" }}>
                                        <Row>
                                            <Col span={12} style={{ fontWeight: 600 }}>Custom Twitter Metadata</Col>
                                            <Col span={12} className="right">
                                                <Toggle id="status" defaultChecked={twitter} onChange={changeTwitter} checked={twitter} />
                                            </Col>
                                        </Row>
                                        <div className={twitter ? 'm-t-10' : `hidden`}>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem className="meta-image" setFieldsValues={setFieldsValues} label="Image" fieldsValues={fieldsValues} labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "twitterCardImage"
                                                        }}
                                                    >
                                                        {fieldsValues.twitImageUrl ? defaultImage(fieldsValues.twitImageUrl, "twitImageUrl") :
                                                            <ImgCrop aspect={1.910828025} rotate>
                                                                <Upload
                                                                    listType="picture"
                                                                    fileList={fileListTwitter}
                                                                    openFileDialogOnClick={true}
                                                                    onChange={onChangeTwitterImage}
                                                                    onPreview={onPreview}
                                                                    beforeUpload={beforeUpload}
                                                                >
                                                                    {fileListTwitter.length == 0 && emptyImage("1200", "628")}
                                                                </Upload>
                                                            </ImgCrop>}

                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "twitTitle"
                                                        }}
                                                    >
                                                        <Input id="twitTitle" defaultValue={fieldsValues.twitTitle} />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={24}>
                                                    <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                                        fieldDecorator={{
                                                            label: "twitDescription"
                                                        }}
                                                    >
                                                        <textarea className="asumsi-input textarea" id="twitDescription" defaultValue={fieldsValues.twitDescription} />
                                                    </FormItem>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Row>
                                        <Col span={24}>
                                            <Divider orientation="left">Google</Divider>
                                            <div style={{ fontSize: 18 }}>
                                                <a>{fieldsValues.metaTitle}</a>
                                            </div>
                                            <div style={{ color: "green", fontSize: 14 }}>
                                                {fieldsValues.canonicalUrl}
                                            </div>
                                            <div style={{ fontSize: 13 }}>
                                                {fieldsValues.metaDescription}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Divider orientation="left">Facebook</Divider>
                                            <Card
                                                className="fb-card"
                                                hoverable
                                                style={{ width: 504 }}
                                                cover={fileListFB.length > 0 || fieldsValues.fbImageUrl ? <img alt="example" src={fileListFB.length > 0 ? fileListFB[0]["thumbUrl"] : fieldsValues.fbImageUrl} /> : null}
                                            >
                                                <Card.Meta description="ASUMSI.CO" className="" />
                                                <Card.Meta title={fieldsValues.fbTitle} />
                                            </Card>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <Divider orientation="left">Twitter</Divider>
                                            <Card
                                                className="twitter-card"
                                                hoverable
                                                style={{ width: 504 }}
                                                cover={fileListTwitter.length > 0 || fieldsValues.twitImageUrl ? <img alt="example" src={fileListTwitter.length > 0 ? fileListTwitter[0]["thumbUrl"] : fieldsValues.twitImageUrl} /> : null}
                                            >
                                                <Card.Meta title={fieldsValues.twitTitle} description={fieldsValues.twitDescription} />
                                                <div style={{ color: "grey", marginTop: "10px", fontSize: "14px" }}>asumsi.co</div>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Skeleton>
            </Form>
        </div>
    );
};
export default PageMetaDataPostFormComponent;



// WEBPACK FOOTER //
// ./src/pages/post-form/libraries/meta-data.tsx